const getBackendBaseUrl = () => {
  const configuredUrl = process.env.REACT_APP_BACKEND_URL?.trim();
  if (configuredUrl) {
    return configuredUrl.replace(/\/$/, "");
  }

  return "";
};

export async function submitWaitlistEmail(email, source = "unknown") {
  const backendBaseUrl = getBackendBaseUrl();
  const endpoint = `${backendBaseUrl}/api/waitlist`;

  const response = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: email.trim().toLowerCase(),
      source,
    }),
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.detail || "Unable to join the waitlist right now.");
  }

  return payload;
}
